<template>
  <div>
    <div :style="'display: flex; flex-direction: column; justify-content: '+(align ? align : 'center')+'; align-items: '+(align ? align : 'center')+'; '+(!notopmargin ? 'top: 0px; ' : '')+'position: relative;;'">
        
        <el-image @click="dialogVisible = true" :src="getImagePath.replace('raizzoncdn.online/eta', 'cdn.easytailorapp.com')" :style="'width: '+image_width+'px; '+(image_height && image_height>0 ? 'height: '+image_height+'px;' : '')+''">
            <div slot="placeholder" class="image-slot">
                Loading<span class="dot">...</span>
            </div>
        </el-image>
    </div>  
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        width="70%">
        <div style="width: 100%; text-align: center;">
            <img :src="getImagePath" alt="" style="max-width: 100%;">
        </div>
        
    </el-dialog>  
  </div>
</template>

<script>

export default {
    props: ['image_path', 'image_width', 'image_height', 'align', 'notopmargin'],
    data() {
        return {
            uploaded_image_path: 'https://etacdn.b-cdn.net/website/blank_image.png',
            dialogVisible: false
        }
    },
    computed: {
        getImagePath() {
            
            if(this.image_path != null && this.image_path.length>0) {
                return this.image_path    
            }
            return this.uploaded_image_path

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/DisplayImage.vue